exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag-action[data-v-1603eea2]{padding:2px 8px;border-radius:10px;font-size:11px;font-weight:600;color:#fff;white-space:nowrap}.tag-action-assigned[data-v-1603eea2]{background:#16a34a}.tag-action-unassigned[data-v-1603eea2]{background:#6b7280}.tag-action-still[data-v-1603eea2]{background:#8b5cf6}.tag-action-created[data-v-1603eea2]{background:#2563eb}.tag-action-updated[data-v-1603eea2]{background:#d97706}.tag-action-deleted[data-v-1603eea2]{background:#dc2626}.tag-system[data-v-1603eea2]{background:#111827;color:#fff;padding:2px 6px;border-radius:4px;font-size:11px}.text-muted[data-v-1603eea2]{color:#9ca3af}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1603eea2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/logPoint/tagHistory.vue
// module id = 1114
// module chunks = 0